import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deletedCardsGroupsChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiAlertCircleOutline } from '@mdi/js';

import { _ } from '../../functions/translator'
import { showMessage } from '../../functions/popUpMessage';


class UnfulfilledButton extends React.Component{
          
    handleClick = async () => {
        let count = this.props.cardsGroupIds.length
        let message = '¿' + _('Estás seguro de cambiar a estado de Incumplimiento') + ' ' + count + ' '
        message += count > 1 ? _('protocolos') : _('protocolo')
        message += '?'
        const messageConfig = {
            closeButton: true,
            unfulfilledStatusConfirmation: true,
            cardsGroupIds: this.props.cardsGroupIds
        };
        showMessage(this.props, message, messageConfig);
        this.props.popUpMenuChange({ show: false })
        this.props.selectedCardsGroupsChange([])
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={this.handleClick}>
                    <div className='d-flex d-inline-flex align-items-center'>
                        <Icon path={ mdiAlertCircleOutline } size='30px' color='white' style={{margin: 10}}/>
                        <p className='text-wrap-button'>{ _('Marcar como Incumplimiento') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole  : state.userRole,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        deletedCardsGroupsChange : deletedCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(UnfulfilledButton)